
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Testimonial',
  props: {
    icon: String,
    name: String,
    suffix: String,
  },
});
